import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import EvaluationMonitorServices from "./EvaluationMonitor.services";
// import gestorDocumentalServices from "../../gestorDocumental/gestorDocumental.services";
// import metricaCompetencia_services from "../metricaCompetencia/metricaCompetencia_services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getEvaluationMonitor = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EVALUATION_MONITOR,
      payload: true,
    });
    let resp;
    if (filters.evaluaciones_actuales || filters.evaluaciones_actuales === "") {
      resp = await EvaluationMonitorServices.getEvaluationMonitor(filters);
    }
    dispatch({
      type: actions.GET_EVALUATION_MONITOR,
      payload: {
        evaluationMonitors:
          filters.evaluaciones_actuales || filters.evaluaciones_actuales === ""
            ? resp.data.data
            : [],
        evaluationMonitorsLength:
          filters.evaluaciones_actuales || filters.evaluaciones_actuales === ""
            ? resp.data.count
            : 0,
      },
    });
    dispatch({
      type: actions.EVALUATION_MONITOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.EVALUATION_MONITOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EVALUATION_MONITOR,
      payload: false,
    });
  }
};

export const getEvaluationMonitorById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EVALUATION_MONITOR_BY_ID,
      payload: true,
    });
    const resp = await EvaluationMonitorServices.getEvaluationMonitorById(id);
    dispatch({
      type: actions.GET_EVALUATION_MONITOR_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.EVALUATION_MONITOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.EVALUATION_MONITOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EVALUATION_MONITOR_BY_ID,
      payload: false,
    });
  }
};

export const getQuestionFactor =
  (filters, data, loader) => async (dispatch) => {
    try {
      // dispatch({
      //   type: actions.LOADING_QUESTION_FACTOR,
      //   payload: true,
      // });
      loader(true);

      const resp = await EvaluationMonitorServices.getQuestionFactor(filters);
      // dispatch({
      //   type: actions.GET_QUESTION_FACTOR,
      //   payload: resp.data,
      // });
      data(resp.data.factores);

      // dispatch({
      //   type: actions.QUESTION_FACTOR_FAIL,
      //   payload: null,
      // });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data[0]) {
                message = ex.response.data[0];
              } else {
                message = messages.errorMessage;
              }
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      // dispatch({
      //   type: actions.QUESTION_FACTOR_FAIL,
      //   payload: message,
      // });

      toastr.error(message);
    } finally {
      // dispatch({
      //   type: actions.LOADING_QUESTION_FACTOR,
      //   payload: false,
      // });
      loader(false);
    }
  };

export const getQuestionCompetency =
  (filters, data, loader) => async (dispatch) => {
    try {
      // dispatch({
      //   type: actions.LOADING_QUESTION_COMPETENCY,
      //   payload: true,
      // });
      loader(true);
      const resp = await EvaluationMonitorServices.getQuestionCompetency(
        filters
      );
      // dispatch({
      //   type: actions.GET_QUESTION_COMPETENCY,
      //   payload: resp.data,
      // });

      data(resp.data.data);
      // dispatch({
      //   type: actions.QUESTION_COMPETENCY_FAIL,
      //   payload: null,
      // });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data[0]) {
                message = ex.response.data[0];
              } else {
                message = messages.errorMessage;
              }
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      // dispatch({
      //   type: actions.QUESTION_COMPETENCY_FAIL,
      //   payload: message,
      // });

      toastr.error(message);
    } finally {
      // dispatch({
      //   type: actions.LOADING_QUESTION_COMPETENCY,
      //   payload: false,
      // });
      loader(false);
    }
  };

export const getMetricaCompetencia =
  (filters, data, loader) => async (dispatch) => {
    try {
      // dispatch({
      //   type: actions.LOADING_QUESTION_COMPETENCY,
      //   payload: true,
      // });
      loader(true);
      const resp = await EvaluationMonitorServices.getMetricaCompetencia(
        filters
      );
      // dispatch({
      //   type: actions.GET_QUESTION_COMPETENCY,
      //   payload: resp.data,
      // });

      data(resp.data.data);
      // dispatch({
      //   type: actions.QUESTION_COMPETENCY_FAIL,
      //   payload: null,
      // });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data[0]) {
                message = ex.response.data[0];
              } else {
                message = messages.errorMessage;
              }
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      // dispatch({
      //   type: actions.QUESTION_COMPETENCY_FAIL,
      //   payload: message,
      // });

      toastr.error(message);
    } finally {
      // dispatch({
      //   type: actions.LOADING_QUESTION_COMPETENCY,
      //   payload: false,
      // });
      loader(false);
    }
  };

export const getMetricByFactor =
  (filters, data, loader) => async (dispatch) => {
    try {
      // dispatch({
      //   type: actions.LOADING_QUESTION_COMPETENCY,
      //   payload: true,
      // });
      loader(true);
      const resp = await EvaluationMonitorServices.getMetricByFactor(filters);
      // dispatch({
      //   type: actions.GET_QUESTION_COMPETENCY,
      //   payload: resp.data,
      // });

      data(resp.data.data);
      // dispatch({
      //   type: actions.QUESTION_COMPETENCY_FAIL,
      //   payload: null,
      // });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data[0]) {
                message = ex.response.data[0];
              } else {
                message = messages.errorMessage;
              }
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      // dispatch({
      //   type: actions.QUESTION_COMPETENCY_FAIL,
      //   payload: message,
      // });

      toastr.error(message);
    } finally {
      // dispatch({
      //   type: actions.LOADING_QUESTION_COMPETENCY,
      //   payload: false,
      // });
      loader(false);
    }
  };

export const saveEvaluationMonitor =
  (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_EVALUATION_MONITOR,
        payload: true,
      });
      const resp = await EvaluationMonitorServices.saveEvaluationMonitor(data);
      const { evaluationMonitors, evaluationMonitorsLength } =
        getState().evaluationMonitor;
      const _evaluationMonitors = [...evaluationMonitors, resp.data];
      dispatch({
        type: actions.GET_EVALUATION_MONITOR,
        payload: {
          evaluationMonitors: _evaluationMonitors,
          evaluationMonitorsLength: evaluationMonitorsLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_EVALUATION_MONITOR,
        payload: false,
      });
    }
  };

export const editEvaluationMonitor =
  (data, idFactor, index, setShowModal, type, idCompetencia) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_EVALUATION_MONITOR,
        payload: true,
      });
      const resp = await EvaluationMonitorServices.editEvaluationMonitor(
        idFactor,
        data
      );
      // if (idCompetencia) {
      //   await EvaluationMonitorServices.editEvaluationMonitor(
      //     idCompetencia,
      //     data
      //   );
      // }
      const { evaluationMonitors, evaluationMonitorsLength } =
        getState().evaluationMonitor;
      evaluationMonitors[index] = resp.data;
      dispatch({
        type: actions.GET_EVALUATION_MONITOR,
        payload: {
          evaluationMonitors: evaluationMonitors,
          evaluationMonitorsLength: evaluationMonitorsLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      if (setShowModal) {
        setShowModal(false);
      }
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      if (type) {
        const _data = {
          data: [
            {
              id: idFactor,
              tipo_mensaje: "jefe: Colaborador acepto evaluación",
            },
            {
              id: idFactor,
              tipo_mensaje: "Responsable: Colaborador acepto evaluación",
            },
          ],
        };
        await EvaluationMonitorServices.mailSendEvaluationMonitor(_data);
        toastr.success(messages.correoEnviado, "", {
          progressBar: true,
          rtl: true,
        });
      }
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data) {
                message = ex.response.data;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_EVALUATION_MONITOR,
        payload: false,
      });
    }
  };

export const editEvaluationMonitorNotAccept =
  (data, idFactor, index, type) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_EVALUATION_MONITOR,
        payload: true,
      });
      await EvaluationMonitorServices.editEvaluationMonitorNotAccept(data);
      const { evaluationMonitors, evaluationMonitorsLength } =
        getState().evaluationMonitor;
      evaluationMonitors[index].estado = null;
      dispatch({
        type: actions.GET_EVALUATION_MONITOR,
        payload: {
          evaluationMonitors: evaluationMonitors,
          evaluationMonitorsLength: evaluationMonitorsLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      if (type) {
        const _data = {
          data: [
            {
              id: idFactor,
              tipo_mensaje: "jefe: Colaborador no acepto evaluación",
            },
            {
              id: idFactor,
              tipo_mensaje: "Responsable: Colaborador no acepto evaluación",
            },
          ],
        };
        await EvaluationMonitorServices.mailSendEvaluationMonitor(_data);
        toastr.success(messages.correoEnviado, "", {
          progressBar: true,
          rtl: true,
        });
      }
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data) {
                message = ex.response.data;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      toastr.error(message, "", {
        progressBar: true,
        rtl: true,
      });
    } finally {
      dispatch({
        type: actions.LOADING_EVALUATION_MONITOR,
        payload: false,
      });
    }
  };

export const editEvaluationMonitorGD =
  (dataGD, setShowModal, editItem, index, exist, type) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_EVALUATION_MONITOR,
        payload: true,
      });
      var respGD = {};
      var resp = {};
      if (type === 1) {
        if (exist) {
          respGD = await EvaluationMonitorServices.saveEvaluationMonitorGD(
            dataGD
          );
        }
      } else {
        if (exist) {
          respGD = await EvaluationMonitorServices.editEvaluationMonitorGD(
            editItem.evaluacion_archivo_plan_accion_gestor,
            dataGD
          );
        }
      }
      if (respGD && respGD.data && respGD.data.resultado) {
        resp = await EvaluationMonitorServices.editEvaluationMonitor(
          editItem.id,
          {
            ...editItem,
            evaluacion_archivo_plan_accion_gestor: respGD.data.resultado.id,
          }
        );
      } else {
        resp = await EvaluationMonitorServices.editEvaluationMonitor(
          editItem.id,
          editItem
        );
      }
      const { evaluationMonitors, evaluationMonitorsLength } =
        getState().evaluationMonitor;
      evaluationMonitors[index] = resp.data;
      dispatch({
        type: actions.GET_EVALUATION_MONITOR,
        payload: {
          evaluationMonitors: evaluationMonitors,
          evaluationMonitorsLength: evaluationMonitorsLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_EVALUATION_MONITOR,
        payload: false,
      });
    }
  };

export const editEvaluationMonitorCheck =
  (data, id, index, setLoading) => async (dispatch, getState) => {
    try {
      setLoading(true);
      const resp = await EvaluationMonitorServices.editEvaluationMonitor(
        id,
        data
      );
      const { evaluationMonitors, evaluationMonitorsLength } =
        getState().evaluationMonitor;
      evaluationMonitors[index] = resp.data;
      dispatch({
        type: actions.GET_EVALUATION_MONITOR,
        payload: {
          evaluationMonitors: evaluationMonitors,
          evaluationMonitorsLength: evaluationMonitorsLength,
        },
      });

      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      console.error(message);
    } finally {
      setLoading(false);
    }
  };

export const updateBoss =
  (req, index, setLoading, _getEvaluationMonitor) => async (dispatch) => {
    try {
      setLoading(true);
      await EvaluationMonitorServices.updateBoss(req);
      // const { evaluationMonitors, evaluationMonitorsLength } =
      //   getState().evaluationMonitor;
      // evaluationMonitors[index] = resp.data;
      // dispatch({
      //   type: actions.GET_EVALUATION_MONITOR,
      //   payload: {
      //     evaluationMonitors: evaluationMonitors,
      //     evaluationMonitorsLength: evaluationMonitorsLength,
      //   },
      // });
      // dispatch({
      //   type: actions.FORM_FAIL,
      //   payload: "",
      // });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data) {
                message = ex.response.data;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      _getEvaluationMonitor();
      setLoading(false);
    }
  };

export const deleteEvaluationMonitor =
  (req, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_EVALUATION_MONITOR,
        payload: true,
      });
      await EvaluationMonitorServices.deleteEvaluationMonitor(req);
      const { evaluationMonitors, evaluationMonitorsLength } =
        getState().evaluationMonitor;
      evaluationMonitors.splice(index, 1);
      dispatch({
        type: actions.GET_EVALUATION_MONITOR,
        payload: {
          evaluationMonitors: evaluationMonitors,
          evaluationMonitorsLength: evaluationMonitorsLength - 1,
        },
      });
      dispatch({
        type: actions.EVALUATION_MONITOR_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.EVALUATION_MONITOR_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_EVALUATION_MONITOR,
        payload: false,
      });
    }
  };
